// Estado de reportes

export function getReportStatuses() {
  return [
    { value: "NEW", label: "Nuevo" },
    { value: "IN_REVIEW", label: "En revisión" },
    { value: "CONFIRMED", label: "Confirmado" },
    { value: "IN_PROGRESS", label: "En progreso" },
    { value: "RESOLVED", label: "Resuelto" },
    { value: "CLOSED", label: "Cerrado" }
  ];
}

export function getReportStatusLabel(status) {
  const type = getReportStatuses().find((t) => t.value === status);
  return type ? type.label : status;
}
